import { exeRequest } from '../utils/APIUtils';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // Liste complète (admin)
    getAll: async () => exeRequest('/admin/vehicle-service-classes', 'GET'),

    // Détail
    getById: async (id) => exeRequest(`/admin/vehicle-service-classes/${id}`, 'GET'),

    // Créer
    create: async (data) => exeRequest('/admin/vehicle-service-classes', 'POST', data),

    // Modifier
    update: async (id, data) => exeRequest(`/admin/vehicle-service-classes/${id}`, 'PUT', data),

    // Supprimer
    remove: async (id) => exeRequest(`/admin/vehicle-service-classes/${id}`, 'DELETE'),

    // Toggle actif/inactif
    toggle: async (id, isActive) => exeRequest(`/admin/vehicle-service-classes/${id}/toggle`, 'PATCH', { isActive }),

    // Seed initial (19 classes Yango)
    seed: async () => exeRequest('/admin/vehicle-service-classes/seed', 'POST'),
};
